import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 px-4 md:px-8 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20dramatic%20light%20burst%20through%20darkness%2C%20abstract%20geometric%20rays%2C%20hope%20and%20truth%20concept%2C%20cinematic%20atmosphere%2C%20amber%20and%20soft%20crimson%20tones%2C%20minimalist%20composition%2C%20inspirational%20mood&width=1600&height=700&seq=cta-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/60"></div>

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-background-50 mb-4 font-heading">
          不想成为下一个受害者？
        </h2>
        <p className="text-base text-background-50/70 mb-8 leading-relaxed">
          在投入资金之前，花几分钟了解51cg平台的真实情况。你的每一分钱都来之不易，别让它成为别人的囊中之物。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/fengxian-tishi"
            className="px-8 py-3.5 text-sm font-semibold bg-accent-500 text-foreground-950 rounded-lg hover:bg-accent-400 transition-all cursor-pointer whitespace-nowrap"
          >
            查看风险提示
          </Link>
          <Link
            to="/category/yonghu-pingjia"
            className="px-8 py-3.5 text-sm font-semibold bg-background-50/10 text-background-50 rounded-lg hover:bg-background-50/20 backdrop-blur-sm transition-all cursor-pointer whitespace-nowrap border border-background-50/20"
          >
            阅读用户评价
          </Link>
        </div>
      </div>
    </section>
  );
}